module.exports = __webpack_public_path__ + "img/collections.94f8912.png";